// Canonical DTC data — single source for notifications, DiagnosticsPage, and DiagnosticsDtcPage.
// nodeId must match a node id returned by discoverMockNetwork() so DTC notifications
// are only shown when the relevant node is actually present on the network.
export const MOCK_DTCS = [
  {
    id: "U0100",
    nodeId: "ved-bridge",
    node: "cBerry VE.direct Bridge",
    description: "Lost communication with MPPT controller",
    timestamp: "2026-05-22 10:34:15",
    severity: "critical",
  },
  {
    id: "C0063",
    nodeId: "bms-bridge",
    node: "cBerry BMS Bridge",
    description: "Cell voltage imbalance — max delta 87 mV",
    timestamp: "2026-05-22 09:12:45",
    severity: "warning",
  },
  {
    id: "P0A7D",
    nodeId: "ewl-1",
    node: "cBerry EWL-810 #1",
    description: "Ch 3 overcurrent — soft fuse opened",
    timestamp: "2026-05-22 08:55:01",
    severity: "warning",
  },
];
